import { Button, Card, CardContent, CardHeader, CircularProgress, Dialog, DialogContent, Table, TableBody, TableCell, TableRow, Tooltip, TableHead, Typography } from "@mui/material";
import { AddToQueue, BorderColor, Delete, PictureAsPdf } from "@mui/icons-material";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { errorToast } from "../../helpers/Notification";
import { getError } from "store/helpers/common_functions";
import { mapStateToProps } from "store/helpers/mapState";
import { mapDispatchToProps } from "store/helpers/mapDispatch";
import OpenDocument from "helpers/openDocument";
import { getFileMime } from "helpers/Common_functions";
import DeleteDialog from "helpers/DeleteDialog";
import FormDialog from "helpers/FormDialog";
import QtMaterialButton from "components/QtMaterialButton";
// import { TableHead } from "mui-datatables";

const EmployeeDocuments = ({ resource, FetchDetails, resourceId, loggedUser, onSuccess }) => {
    const [fileView, setFileView] = useState(null);
    const [open, setOpen] = useState(0);
    const [value, setValue] = useState({});
    const [id, setId] = useState();
    const [deleteOpen, setDeleteOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [resourceDocuments, setResourceDocuments] = useState([]);

    const setValue0 = (name, val) => {
        if (!name) return null;
        setValue((v) => ({ ...v, [name]: val }));
    };

    const loadAttachments = async () => {
        setIsLoading(true);
        const resp = await FetchDetails(`/api/resource/attachment/list/${resourceId}`);
        if (resp.status) {
            setResourceDocuments(resp?.data);
        } else {
            errorToast(getError(resp));
        }
        setIsLoading(false);
    };

    useEffect(() => {
        loadAttachments();
    }, [resourceId]);

    return (
        <Card>
            <CardHeader
                action={
                    <QtMaterialButton startIcon={<AddToQueue />} variant="contained" onClick={() => setOpen(1)}>
                        Add New
                    </QtMaterialButton>
                }
            />
            <CardContent>
                <Table>
                    {resourceDocuments?.length > 0 && (
                       
                    <TableHead>
                        <TableRow>
                            <TableCell>Attachment Name</TableCell>
                            <TableCell>Uploaded Date</TableCell>
                            <TableCell>Actions</TableCell>
                        </TableRow>
                    </TableHead>
                    )}
                    <TableBody>
                        {isLoading ? (
                            <TableRow>
                                <TableCell colSpan={2} className="text-center">
                                    <CircularProgress />
                                </TableCell>
                            </TableRow>
                        ) : resourceDocuments?.length > 0 ? (
                            resourceDocuments.map((v, index) => (

                                <TableRow key={index}>
                                    <TableCell>
                                        <Tooltip title={v?.name}>
                                            <Button
                                                startIcon={<PictureAsPdf />}
                                                onClick={() => {
                                                    setFileView(v.attachment);
                                                }}
                                            >
                                                {v?.name}
                                            </Button>
                                        </Tooltip>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant="body2" color="text.secondary">
                                            {v?.createdAt ? new Date(v?.createdAt).toLocaleDateString() : ""}
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Tooltip title="Edit">
                                            <BorderColor
                                                fontSize="small"
                                                onClick={() => {
                                                    setOpen(2);
                                                    setId(v?.id);
                                                    setValue0("name", v.name);
                                                }}
                                            />
                                        </Tooltip>
                                        <Tooltip title="Delete">
                                            <Delete
                                                fontSize="small"
                                                color="error"
                                                onClick={() => {
                                                    setDeleteOpen(true);
                                                    setId(v?.id);
                                                }}
                                            />
                                        </Tooltip>
                                    </TableCell>
                                </TableRow>
                            ))
                        ) : (
                            <TableRow>
                                <TableCell colSpan={2} className="text-center">
                                    No document found.
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </CardContent>

            {fileView && (
                <Dialog maxWidth={'md'} fullWidth={true} open={fileView !== null} onClose={() => setFileView(null)}>
                    <DialogContent>
                        {fileView !== null && <OpenDocument
                            downloadable={true}
                            document={fileView}
                            name={'supportDocument'}
                            specialName={fileView}
                            type={"permission-doc"}
                            mimeType={getFileMime(fileView)} />}
                    </DialogContent>
                </Dialog>
            )}

            <DeleteDialog
                url={`/api/resource/attachment/${id}`}
                open={deleteOpen}
                setOpen={setDeleteOpen}
                onSuccess={() => {
                    setOpen(0);
                    onSuccess();
                    loadAttachments();
                }}
                title="Delete Document"
            />

            <FormDialog
                onSuccess={() => {
                    setOpen(0);
                    onSuccess();
                    loadAttachments();
                }}
                url={open === 1 ? "/api/resource/attachment" : `/api/resource/attachment/update/${id}`}
                fields={[
                    {
                        name: "name",
                        label: "Attachment Name",
                        type: "text",
                        value: value["name"],
                        required: true,
                        setValue: (val) => setValue0("name", val),
                    },
                    {
                        name: "resourceId",
                        label: "Resource",
                        type: "select",
                        values: [{ label: resource?.name, value: resource?.id }],
                        value: resource?.id,
                        required: true,
                        disabled: true,
                        hidden: true,
                    },
                    {
                        name: "uploaderId",
                        label: "Uploader",
                        type: "select",
                        values: [{ label: loggedUser?.name, value: loggedUser?.id }],
                        value: loggedUser?.id,
                        required: true,
                        disabled: true,
                        hidden: true,
                    },
                    {
                        name: "attachment",
                        label: "Attachment",
                        type: "file-drag",
                        value: value["attachment"],
                        required: open === 1,
                        setValue: (val) => setValue0("attachment", val),
                    },
                ]}
                open={open}
                setOpen={setOpen}
                title={open === 1 ? "Create New Document" : "Update Document"}
            />
        </Card>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(EmployeeDocuments);